import { Component, DestroyRef, input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatListOption, MatSelectionList } from '@angular/material/list';
import { tap } from 'rxjs';

export type ListViewExternalCheckboxFilterValue<TValue extends string | number | boolean = string> = TValue[];

export type CheckboxFilterFormCtrl = FormControl<ListViewExternalCheckboxFilterValue | null>;

export function createCheckboxFilterFormCtrl(): CheckboxFilterFormCtrl {
  return new FormControl(null);
}

@Component({
  selector: 'dojo-list-view-checkbox-filter',
  template: `
    <h4 class="text-md text-primary mb-4 font-semibold">{{ label() }}</h4>
    <mat-selection-list [formControl]="formCtrl()" class="custom-selection-list-checkbox-appearance">
      @for (option of options(); track $index) {
        <mat-list-option [togglePosition]="'before'" [value]="option">{{ option }}</mat-list-option>
      }
    </mat-selection-list>
  `,
  imports: [MatSelectionList, ReactiveFormsModule, MatListOption],
})
export class ListViewCheckboxFilterComponent implements OnInit {
  constructor(private readonly destroyRef: DestroyRef) {}
  readonly formCtrl = input.required<CheckboxFilterFormCtrl>();
  readonly options = input.required<string[]>();
  readonly label = input.required<string>();

  ngOnInit() {
    this.setNullValueIfArrayEmpty().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }

  setNullValueIfArrayEmpty() {
    return this.formCtrl().valueChanges.pipe(
      tap((value) => {
        if (Array.isArray(value) && value.length === 0) {
          this.formCtrl().setValue(null);
        }
      }),
    );
  }
}
